import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/autzuLogoBlack.png';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import ScrollLock from 'react-scrolllock';
import './autzuLogoLayout.css';

class AutzuLogoLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  onClose = () => this.setState({ isOpen: false });

  openModal = () => {
    this.setState({ isOpen: true });
  };

  render() {
    const { children } = this.props;
    return (
      <ScrollLock>
        <div className="layout-section">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <FontAwesomeIcon className="x-icon" icon={faTimes} />
          </Link>
          <div className="container layout-background">
            <Link className="layout-logo" to="/" style={{ textDecoration: 'none' }}>
              <img className="white-logo" src={logo} alt="Autzu Logo" />
            </Link>
            <div className="layout-form">{children}</div>
          </div>
        </div>
      </ScrollLock>
    );
  }
}

export default AutzuLogoLayout;



// WEBPACK FOOTER //
// ./src/components/User/AutzuLogoLayout.js